import React, { useCallback, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH, faSort } from "@fortawesome/free-solid-svg-icons";
import "./Workflows.scss";

export default function WorkflowsTable() {
  const navigate = useNavigate();

  // Dummy data
  const [workflows, setWorkflows] = useState([
    { id: 1, name: "MDD Outreach Flow",    study: "MDD Winter Park",   source: "Facebook Campaign",  active: true  },
    { id: 2, name: "Diabetes Prescreen",   study: "Type 2 Diabetes",   source: "Google Ads Campaign",active: false },
    { id: 3, name: "General Health Intro", study: "Healthy Living",    source: "Instagram Ads",      active: true  },
  ]);

  const [search, setSearch] = useState("");
  const [searchCount, setSearchCount] = useState(0);
  const incSearchCount = useCallback(() => setSearchCount((p) => p + 1), []);
  const debounceSearch = useCallback(_.debounce((v) => setSearch(v), 500), []);

  const toggleActive = useCallback((id) => {
    setWorkflows((prev) =>
      prev.map((wf) => (wf.id === id ? { ...wf, active: !wf.active } : wf))
    );
  }, []);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return workflows;
    return workflows.filter((wf) =>
      [wf.name, wf.study, wf.source].some((v) =>
        String(v ?? "").toLowerCase().includes(q)
      )
    );
  }, [workflows, search]);

    const stickyThStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "#F4F4F4", 
    zIndex: 2,
    fontSize: "0.875rem",
    textAlign: "left",
  };

  const HeadCell = ({ children, className = "" }) => (
    <th style={stickyThStyle} className={`py-2 text-start ${className}`} scope="col">
      <div className="d-inline-flex align-items-center justify-content-start gap-1">
        <span>{children}</span>
     
      </div>
    </th>
  );

  return (
    <div className="container-fluid px-4 pt-2 d-flex flex-column"style={{ position: "sticky", top: 0 }}
>
     
      <div className="d-flex justify-content-between align-items-end mb-1 ">
        <div className="col">
            <h4 className="mb-0 ps-4"style={{ color: '#2E2868' }}>Workflows</h4>
           </div>

        <div className="d-flex align-items-center gap-2">
         <div className="col-auto ms-auto position-relative">
                    <input autoFocus className="search-input width_200" defaultValue={search} key={searchCount} placeholder="Search..." onChange={e => debounceSearch(e.target.value)} /> 
                     <i className="bi bi-x position-absolute top-50 end-0 translate-middle-y me-3 text-muted" onClick={() => { setSearch(''); incSearchCount(); }} role="button"></i> 
                  </div>
       <div className="col-auto">
            <Link to="/app/customers/workflows/new">
              <button className="btn btn-primary" style={{ backgroundColor: "#2E2868", borderColor: "#2E2868", marginLeft: "20px", }}>Create New Workflow</button>
            </Link>
          </div>
        </div>
      </div>
       <hr />
     

      {/* Table container (same rounded/bordered feel) */}
      <div className="border rounded-3 overflow-auto" style={{ maxHeight: "calc(100vh - 100px)" }}>
        <table
          className="table table-sm table-borderless align-middle mb-0"
          style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.875rem", tableLayout: "auto" }} // same font size
        >
          <thead className="text-muted small" style={{ height: "30px" }}>
            <tr className="border-bottom">
              <HeadCell className="text-start align-middle py-2 ps-3">Name</HeadCell>
              <HeadCell className="text-start align-middle py-2 ps-3">Study</HeadCell>
              <HeadCell className="text-start align-middle py-2 ps-3">Recruiting Source</HeadCell>
              <HeadCell className="text-start align-middle py-2 ps-3">Actions</HeadCell>
            </tr>
          </thead>

          <tbody>
            {filtered.map((wf) => (
              <tr key={wf.id} className="border-bottom" style={{ height: "30px" }}>
                {/* Name */}
                <td className="text-start align-middle py-2 ps-3" style={{ borderRight: "1px solid #ccc", paddingRight: 12 }}>
                  <Link
                    to={`/app/workflows/${wf.id}`}
                    className="fw-semibold text-decoration-none"
                    style={{ color: "#2E2868" }}
                  >
                    {wf.name}
                  </Link>
                </td>

                {/* Study */}
                <td className="text-start align-middle py-2 ps-3" style={{ borderRight: "1px solid #ccc", padding: "0 12px" }}>
                  {wf.study}
                </td>

                {/* Source */}
                <td className="text-start align-middle py-2 ps-3" style={{ borderRight: "1px solid #ccc", padding: "0 12px" }}>
                  {wf.source}
                </td>

                {/* Actions (toggle + menu) */}
                <td className="text-start align-middle py-2 ps-3" style={{ padding: "0 12px" }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="form-check form-switch d-inline-block">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={wf.active}
                        onChange={() => toggleActive(wf.id)}
                        style={{ backgroundColor: wf.active ? "#2E2868" : "" }}
                        aria-label={wf.active ? "Deactivate workflow" : "Activate workflow"}
                      />
                    </div>

                    <Dropdown align="end">
                      <Dropdown.Toggle
                        as="button"
                        variant="light"
                        size="sm"
                        className="border-0 bg-transparent dropdown-toggle-no-caret"
                      >
                        <FontAwesomeIcon icon={faEllipsisH} style={{ color: "gray" }} size="lg" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} to={`/app/workflows/${wf.id}/edit`}>Edit</Dropdown.Item>
                        <Dropdown.Item>Duplicate</Dropdown.Item>
                        <Dropdown.Item className="text-danger">Delete</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Small tweak: make checked switch match brand color */}
      <style>{`
        .form-check-input:checked {
          background-color: #2E2868 !important;
          border-color: #2E2868 !important;
        }
      `}</style>
    </div>
  );
}
